import { Typography } from 'ui-v2/components/Typography';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import s from './Tab.module.scss';
import classNames from 'classnames';

type TabProps = {
  title: string;
  icon?: string;
  isActive: boolean;
};

export const Tab = ({ title, icon, isActive }: TabProps) => {

  return (
    <div
      style={{
        zIndex: isActive ? 2 : 0,
      }}
      className={classNames(s.root, 'cmn_touchable_area')}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50vw"
        height="36"
        viewBox="0 0 190 36"
        fill="none"
        preserveAspectRatio="none"
      >
        <path
          d="M16.7523 14.6862C19.1294 6.29326 26.7913 0.5 35.5144 0.5H159.486C168.209 0.5 175.871 6.29325 178.248 14.6861L181.544 26.3261C182.753 30.5928 185.866 33.9227 189.804 35.5H5.19583C9.13428 33.9227 12.2472 30.5928 13.4556 26.3261L16.7523 14.6862Z"
          fill={isActive ? 'white' : '#EEE9FE'}
          stroke={isActive && 'url(#paint0_linear_886_40857)'}
        />
        <defs>
          <linearGradient
            id="paint0_linear_886_40857"
            x1="97.5"
            y1="0"
            x2="97.5"
            y2="34.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5430BB" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
      <div className={s.title}>
        {icon && <AnimatedImage src={icon} className={s.icon} />}
        <Typography
          label={title}
          variant="label_3_semi_bold"
          color={isActive ? 'primary' : 'disabled_alpha'}
        />
      </div>
    </div>
  );
};
